import {
  updateDeletedPipes,
  updateDeletedSystems,
  updateUpdatedDatasets,
  updateUpdatedPipes,
  updateUpdatedSystems,
} from '../redux-store/thunks/liveUpdates.thunks';
import { store } from '../internals/store';
import { PipeActions, pipesLoadAllFinished } from '../redux-store/thunks/pipes.thunks';
import {
  systemLoadAllFinished,
  systemsAdded,
  systemsDeleted,
  systemsUpdated,
} from '../redux-store/thunks/systems.thunks';
import {
  datasetsAdded,
  datasetsDeleted,
  datasetsLoadAllFinished,
  datasetsUpdated,
} from '../redux-store/thunks/datasets.thunks';

import type { WebSocketEventMessages } from '../types/network.types';
import type { PipeResponse } from '../types/pipes.types';
import type { System } from '../types/system.types';
import type { Dataset } from '../types/dataset.types';

const getIdsArray = (arr: PipeResponse[] | System[] | Dataset[]) => {
  if (!arr) {
    return [];
  }

  return arr.map((s) => s._id);
};

export const routeMessage = (message: WebSocketEventMessages) => {
  if (!message || !message.type || !message.data || typeof message.type !== 'string') {
    console.warn('Invalid WS message:', message);
    return;
  }

  const storeDispatch = store.dispatch as any;

  switch (message.type) {
    case 'pipes':
      storeDispatch(pipesLoadAllFinished(message.data));
      break;
    case 'pipes_added':
      storeDispatch(PipeActions.updatePipes(message.data));
      break;
    case 'pipes_updated':
      storeDispatch(PipeActions.updatePipes(message.data));
      storeDispatch(updateUpdatedPipes({ pipes: getIdsArray(message.data) }));
      break;
    case 'pipes_deleted':
      storeDispatch(PipeActions.deletePipes(message.data));
      storeDispatch(updateDeletedPipes({ pipes: getIdsArray(message.data) }));
      break;
    case 'systems':
      storeDispatch(systemLoadAllFinished(message.data));
      break;
    case 'systems_added':
      storeDispatch(systemsAdded(message.data));
      break;
    case 'systems_updated':
      storeDispatch(systemsUpdated(message.data));
      storeDispatch(updateUpdatedSystems({ systems: getIdsArray(message.data) }));
      break;
    case 'systems_deleted':
      storeDispatch(systemsDeleted(message.data));
      storeDispatch(updateDeletedSystems({ systems: getIdsArray(message.data) }));
      break;
    case 'datasets':
      storeDispatch(datasetsLoadAllFinished(message.data));
      break;
    case 'datasets_added':
      storeDispatch(datasetsAdded(message.data));
      break;
    case 'datasets_updated':
      storeDispatch(datasetsUpdated(message.data));
      storeDispatch(updateUpdatedDatasets({ datasets: getIdsArray(message.data) }));
      break;
    case 'datasets_deleted':
      storeDispatch(datasetsDeleted(message.data));
      storeDispatch(updateUpdatedDatasets({ datasets: getIdsArray(message.data) }));
      break;
    default:
      console.warn('Unhandled WS message type:', message);
  }
};
